import { AppLink } from "@/components/AppLink/AppLink";
import { CustomerLayout } from "@/components/CustomerLayout/CustomerLayout";
import { DocumentTitle } from "@/components/DocumentTitle/DocumentTitle";
import { createFileRoute } from "@tanstack/react-router";
import css from "./index.module.scss";

export const Route = createFileRoute("/_authenticated-user/hjelp/")({
  head: () => ({
    meta: [{ title: "Hjelp | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  return (
    <CustomerLayout>
      <DocumentTitle>Hjelp</DocumentTitle>

      <ul className={css.articleList}>
        <li>
          <AppLink to="/hjelp/kom-i-gang" variant="underline">
            Kom i gang med elektronisk tinglysing
          </AppLink>
        </li>
        <li>
          <AppLink to="/hjelp/tinglysing-med-vedlegg" variant="underline">
            Tinglysing med vedlegg
          </AppLink>
        </li>
        <li>
          <AppLink to="/hjelp/tresidig-skjote" variant="underline">
            Tresidig skjøte
          </AppLink>
        </li>
        <li>
          <AppLink to="/hjelp/dodsbo-hjemmelserklaering" variant="underline">
            Dødsbo – hjemmelserklæring og hjemmelserklæring med uskifte
          </AppLink>
        </li>
        <li>
          <AppLink to="/hjelp/dodsbo-hjemmelserklaering-og-skifteattest" variant="underline">
            Dødsbo – hjemmelserklæring og skjøte med skifteattest
          </AppLink>
        </li>
        <li>
          <AppLink to="/hjelp/valideringsfeil-fra-kartverket" variant="underline">
            Valideringsfeil fra Kartverket
          </AppLink>
        </li>
        <li>
          <AppLink to="/hjelp/saker-som-ikke-kan-sendes-elektronisk" variant="underline">
            Hvilke saker kan ikke sendes inn elektronisk?
          </AppLink>
        </li>
      </ul>
    </CustomerLayout>
  );
}
